export default __webpack_public_path__ + "static/fraction-a396b2f5382cb96e6ba0ae9ee3d45809.png";